<form
  [formGroup]="form"
  (keydown.enter)="$event.preventDefault()"
  class="flex flex-col h-full overflow-hidden"
>
  <div class="p-4">
    <h2 class="text-lg">
      {{
        data.group?.uuid
          ? ('PRODUCT_FILTER_EDIT_SET' | translate)
          : ('PRODUCT_FILTER_ADD_FILTERSET' | translate)
      }}
    </h2>
  </div>
  <hr />
  <div class="p-4 grid grid-cols-5 gap-6 mt-4 mb-4">
    <div class="col-span-3">
      <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
        <mat-label>{{ 'FILTER_SET_NAME' | translate }}</mat-label>
        <input
          matInput
          formControlName="name"
          class="filter-set-name"
          [placeholder]="'FILTER_SET_NAME' | translate"
        />
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <em-select-product-group
        class="w-full"
        [groups]="otherGroups()"
        [selected]="excludeSetId"
        [label]="'PRODUCT_FILTER_TITLE_EXCLUDE_FITLER_SET' | translate"
        (groupChanged)="updateExcludedGroup($event?.uuid)"
      ></em-select-product-group>
    </div>
  </div>

  <mat-tab-group class="overflow-auto" mat-stretch-tabs="false">
    <mat-tab>
      <ng-template mat-tab-label>
        {{ 'PRODUCT_FILTER_TITLE_AUTOMATIC' | translate }}

        @if (filtersCount; as fCount) {
          ({{ fCount }})
        }
      </ng-template>
      <div class="tab-content text-center compact-theme">
        <em-info-box class="mb-4 -mt-4">
          <ng-container description>
            {{ 'EDIT_PRODUCT_GROUP_FILTERS_DESCRIPTION' | translate }}
          </ng-container>
        </em-info-box>

        @if (
          conditionalStatementListControl.value?.conditionalStatements?.length
        ) {
          <em-conditional-statement-list
            [formGroup]="conditionalStatementListControl"
            [allowEmpty]="true"
          >
            <ng-template let-conditionControl>
              <em-product-group-filter
                [formGroup]="conditionControl"
                [isPriceCrawl]="data.group?.isPriceCrawl || false"
                [isGoogleSPD]="data.group?.isGoogleSPD || false"
                [appendTo]="'mat-dialog-container'"
              ></em-product-group-filter>
            </ng-template>
          </em-conditional-statement-list>
        } @else {
          <em-primary-button (btnClick)="startAddingFilters()">
            {{
              'EDIT_PRODUCT_GROUP_START_ADDING_FILTERS' | translate
            }}</em-primary-button
          >
        }
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="flex items-center">
          {{ 'PRODUCT_FILTER_TITLE_MANUAL' | translate }}

          @if (manualProductsCount; as pCount) {
            (
            @if (pCount.addedCount) {
              <em-icon
                name="add_circle"
                size="sm"
                class="text-success-500"
              ></em-icon
              ><span class="text-success-500">{{ pCount.addedCount }}</span>
            } @else {
              -
            }
            /
            @if (pCount.removedCount) {
              <em-icon
                name="remove_circle"
                size="sm"
                class="text-danger-500"
              ></em-icon
              ><span class="text-danger-500">{{ pCount.removedCount }}</span>
            } @else {
              -
            }

            )
          }
        </div>
      </ng-template>
      <div class="tab-content h-full flex flex-col">
        <em-info-box class="mb-4 -mt-4">
          <ng-container description>
            {{ 'EDIT_PRODUCT_GROUP_MANUAL_DESCRIPTION' | translate }}
          </ng-container>
        </em-info-box>
        <div class="overflow-hidden">
          <em-manual-product-selection
            formControlName="products"
            [countryCode]="countryCode | async"
            [productLimit]="productLimit(data.group)"
          >
          </em-manual-product-selection>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="mt-auto">
    <hr />
    <div class="text-right p-4">
      <em-text-button color="" class="mr-2" (btnClick)="close()">{{
        'ACTIONS_CANCEL' | translate
      }}</em-text-button>

      <em-primary-button [disabled]="!canSave" (btnClick)="saveGroup()">{{
        'SHARED_SAVE' | translate
      }}</em-primary-button>
    </div>
  </div>
</form>
